import InputBase from "../inputFields/InputBase";
import {FormControlLabel} from "@mui/material";
import PropTypes from "prop-types";
import MuiSwitch from "@mui/material/Switch";

class Switch extends InputBase {
  constructor(props) {
    super(props);
    this.state.checked = this.props.checked;
  }

  onChange = (e) => {
    this.setState({checked: e.target.checked});
    this.fireOnChange(e, e.target.checked);
  }

  getValue() {
    return this.state.checked;
  }

  render() {
    return <FormControlLabel
      checked={this.state.checked}
      onChange={this.onChange}
      control={<MuiSwitch color={this.props.color}/>}
      label={this.props.labelElement}
      labelPlacement="end"
    />
  }
}

Switch.propTypes = {
  labelElement: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning']),
}

export default Switch;